import { Model } from 'components/discovery/utils/model.js'

export type ExternalAttributeValue = {
  id: number,
  name: string,
  description?: string | null,
  picture?: string | null,
  css_color?: string | null,
  api_link: string,
  selected: boolean,
}

export type ExternalAttribute = {
  id: number
  values: Array<ExternalAttributeValue>
}

export type ExternalAttributes = {
  attributes: Array<ExternalAttribute>
}

export type AttributeValue = {
  id: number
  name: string
  description: string
  picture: string
  cssColor: string
  apiLink: string
  selected: boolean
  attributeId: number
  disabled: boolean
}

export type Attribute = {
  id: number
  values: Array<AttributeValue>
}

export class AttributeValueModel extends Model<ExternalAttributeValue & { attributeId: number }> implements ExternalAttributeValue {
  id = 0
  name = ''
  description = ''
  picture = ''
  css_color = ''
  api_link = ''
  selected = false

  attributeId = 0

  parse = (): AttributeValue => ({
    id: this.id,
    name: this.name,
    description: this.description || '',
    picture: this.picture || '',
    cssColor: this.css_color || '',
    apiLink: this.api_link || '',
    selected: this.selected || false,
    attributeId: this.attributeId,
    disabled: false,
  })
}

export class FilterAttributesModel extends Model<ExternalAttributes> implements ExternalAttributes {
  attributes: Array<ExternalAttribute> = []

  parse = (): FilterAttributes => {
    const attributeValuesMap: Map<symbol, AttributeValue> = new Map()

    this.attributes.forEach(attribute => {
      attribute.values.forEach(attributeValue => {
        const key = FilterAttributes.keyFor(attribute.id, attributeValue.id)
        attributeValuesMap.set(key, new AttributeValueModel().with({
          ...attributeValue,
          attributeId: attribute.id,
        }).parse())
      })
    })

    return new FilterAttributes(attributeValuesMap)
  }
}

export class FilterAttributes {
  private attributes: Map<symbol, AttributeValue>

  constructor(attributes: Map<symbol, AttributeValue>) {
    this.attributes = attributes
  }

  getAttributeValue = (attributeId: number, attributeValueId: number): AttributeValue => {
    const attributeValue = this.attributes.get(FilterAttributes.keyFor(attributeId, attributeValueId))

    if (attributeValue === undefined) { throw 'No value, too bad... Should not happen though.' }
    return attributeValue
  }

  merge = (newAttributes: FilterAttributes) => {
    this.attributes.forEach(value => {
      value.disabled = true
      value.selected = false
    })

    return new FilterAttributes(new Map([...this.attributes, ...newAttributes.attributes]))
  }

  static keyFor = (attributeId: number, valueId: number): symbol => Symbol.for(`${attributeId}-${valueId}`)
}
